<template>
    <div
        class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center gap-2 md:gap-8 lg:max-w-(--breakpoint-sm)"
    >
        <vx-expandable-card>
            <template v-slot:content>
                <div class="font-extrabold text-base mb-2 flex items-center justify-between">
                    <span>Details</span>
                    <vx-button v-if="allowEditContact" :href="`/contacts/${props.contactId}`" outline color="muted"
                        >Edit <font-awesome-icon widthAuto :icon="faPen"></font-awesome-icon
                    ></vx-button>
                </div>
                <contact-view-content
                    @currentGroupRemoved="emit('currentGroupRemoved')"
                    :allowEditContact="props.allowEditContact"
                    :editableRelationships="props.editableRelationships"
                ></contact-view-content>
            </template>
        </vx-expandable-card>
    </div>
</template>

<script setup>
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';
import ContactViewContent from '~/components/contacts/contact/view/ContactViewContent.vue';

const props = defineProps({
    contactId: {
        type: Number,
        required: false,
    },
    allowEditContact: {
        type: Boolean,
        default: true,
    },
    editableRelationships: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['currentGroupRemoved']);
</script>
